import { Option, none, isNone, some, isSome } from 'fp-ts/lib/Option';

export type WidgetDataProxyContext = {
    language: string | null;
    location: string | null;
    period: string | null;
    dashboardId: string | null;
    locationTags: string[] | null;
};
export default interface ReadWidgetDataCriteria {
    widgetId: string;
    destination: string;
    proxyContext: WidgetDataProxyContext;
    reportInstanceId: string | null;
    frameText: string;
    periodFrom: string | null;
    periodTo: string | null;
}

class ReadWidgetDataCriteriaImpl implements ReadWidgetDataCriteria {
    constructor(
        readonly widgetId: string,
        readonly destination: string,
        readonly proxyContext: WidgetDataProxyContext,
        readonly reportInstanceId: string | null,
        readonly frameText: string,
        readonly periodFrom: string | null,
        readonly periodTo: string | null
    ) {}
}

export class ReadWidgetDataCriteriaBuilder {
    private widgetId: Option<string> = none;

    private destination: Option<string> = none;

    private proxyContext: Option<WidgetDataProxyContext> = none;

    private reportInstanceId: Option<string> = none;

    private frameText: Option<string> = none;

    private periodFrom: Option<string> = none;

    private periodTo: Option<string> = none;

    static create = (): ReadWidgetDataCriteriaBuilder => new ReadWidgetDataCriteriaBuilder();

    withWidgetId = (widgetId: string): ReadWidgetDataCriteriaBuilder => {
        this.widgetId = some(widgetId);

        return this;
    };

    withDestination = (destination: string): ReadWidgetDataCriteriaBuilder => {
        this.destination = some(destination);

        return this;
    };

    withReportTemplateProxyContext = (context: WidgetDataProxyContext): ReadWidgetDataCriteriaBuilder => {
        this.proxyContext = some(context);

        return this;
    };

    withReportInstanceId = (reportInstanceId: string): ReadWidgetDataCriteriaBuilder => {
        this.reportInstanceId = some(reportInstanceId);

        return this;
    };

    withFrameText = (frameText?: string): ReadWidgetDataCriteriaBuilder => {
        this.frameText = some(frameText || '');

        return this;
    };

    withPeriodFrom = (periodFrom: string): ReadWidgetDataCriteriaBuilder => {
        this.periodFrom = some(periodFrom);

        return this;
    };

    withPeriodTo = (periodTo: string): ReadWidgetDataCriteriaBuilder => {
        this.periodTo = some(periodTo);

        return this;
    };

    build = (): ReadWidgetDataCriteria => {
        if (isNone(this.widgetId)) {
            throw new ReferenceError('Undefined prop');
        }
        return new ReadWidgetDataCriteriaImpl(
            this.widgetId.value,
            isSome(this.destination) ? this.destination.value : 'widgets',
            isSome(this.proxyContext)
                ? this.proxyContext.value
                : { language: null, location: null, period: null, dashboardId: null, locationTags: null },
            isSome(this.reportInstanceId) ? this.reportInstanceId.value : null,
            isSome(this.frameText) ? this.frameText.value : '',
            isSome(this.periodFrom) ? this.periodFrom.value : null,
            isSome(this.periodTo) ? this.periodTo.value : null
        );
    };
}
